import { render } from "./ShowChat.vue?vue&type=template&id=46e5e8d3&scoped=true"
import script from "./ShowChat.vue?vue&type=script&lang=js"
export * from "./ShowChat.vue?vue&type=script&lang=js"

import "./ShowChat.vue?vue&type=style&index=0&id=46e5e8d3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e5e8d3"]])

export default __exports__